import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { FormWidgetPersonModule } from '@modules/bcm/@work-flows/@form-widgets/person/form-widget-person.module';
import { FormWidgetBerthModule } from '@modules/bcm/@work-flows/@form-widgets/berth/form-widget-berth.module';
import { FormWidgetBoatModule } from '@modules/bcm/@work-flows/@form-widgets/boat/form-widget-boat.module';
import { FormWidgetCompanyModule } from '@modules/bcm/@work-flows/@form-widgets/company/form-widget-company.module';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PremiumFormWidgetElectricMeterModule } from '@modules/bcm/@work-flows/@form-widgets/@premium/electric-meter/premium-form-widget-electric-meter.module';
import { FormWidgetBerthFeeModule } from '@modules/bcm/@work-flows/@form-widgets/berth-fee/form-widget-berth-fee.module';
import { FormWidgetTenantRelationModule } from '@modules/bcm/@work-flows/@form-widgets/tenant-relation/form-widget-tenant-relation.module';
import { FormWidgetContractModule } from '@bcm-work-flows/@form-widgets/contract/form-widget-contract.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormWidgetContractCoOwnerModule } from '@bcm-work-flows/@form-widgets/contract-co-owner/form-widget-contract-co-owner.module';
import { BerthReservationComponent } from '@bcm-work-flows/berth-reservation/berth-reservation.component';
import { FormWidgetDateRangeModule } from '@bcm-work-flows/@form-widgets/date-range/form-widget-date-range.module';
import { FormWidgetBerthOnlyModule } from '@bcm-work-flows/@form-widgets/berth-only/form-widget-berth-only.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { FormWidgetInvoiceModule } from '@bcm-work-flows/@form-widgets/invoice/form-widget-invoice.module';
import { GetProductSubscriptionDatesDialogModule } from '@sharedComponents/dialogs/get-product-subscription-dates-dialog/get-product-subscription-dates-dialog.module';
import { TranslationModule } from '@core/translation/translation.module';
import { GetCostCenterForInvoicePositionsDialogModule } from '@modules/bcm/@shared/components/dialogs/get-cost-center-for-invoice-positions-dialog/get-cost-center-for-invoice-positions-dialog.module';

@NgModule({
    declarations: [BerthReservationComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        FlexModule,
        DragDropModule,
        ScrollingModule,

        MatToolbarModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatRadioModule,
        MatDividerModule,

        FormWidgetPersonModule,
        FormWidgetBerthModule,
        FormWidgetBoatModule,
        FormWidgetCompanyModule,
        FormWidgetContractModule,
        FormWidgetContractCoOwnerModule,
        DirectivesModule,
        PremiumFormWidgetElectricMeterModule,
        FormWidgetBerthFeeModule,
        FormWidgetTenantRelationModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        FormWidgetDateRangeModule,
        FormWidgetBerthOnlyModule,
        MatCheckboxModule,
        MatInputModule,
        DateTimeInputModule,
        FormWidgetInvoiceModule,
        GetProductSubscriptionDatesDialogModule,
        TranslationModule,
        GetCostCenterForInvoicePositionsDialogModule,
    ],
    exports: [BerthReservationComponent]
})
export class BerthReservationModule {

}
